import {useQuery} from '@tanstack/react-query';
import {ConsultProtocolsParams} from 'domain/usecases';

import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

import {getProtocols} from '../../services/getProtocols';

export const useListProtocolsQuery = (params: ConsultProtocolsParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.CONSULT_PROTOCOLS, params],
		queryFn: ({signal}) => getProtocols({...params, signal}),
		enabled: !!params.initialDate && !!params.finalDate,
		retry: 2,
	});
